import { createRouter, createWebHashHistory } from 'vue-router'

const routes = [
  // 登录页面路由
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue')
  },
  {
    path: '/screen',
    name: 'DataScreen',
    component: () => import('@/views/screen/index.vue'),
    meta: {
      requiresAuth: true,
      title: '数据大屏'
    }
  },
  // 主布局路由，包含导航栏和侧边栏
  {
    path: '/',
    component: () => import('@/layout/index.vue'),
    meta: {
      requiresAuth: true
    },
    children: [
      {
        path: 'dashboard',
        name: 'Dashboard',
        component: () => import('@/views/dashboard/index.vue'),
        meta: {
          title: '仪表盘',
          icon: 'House',
          requiresAuth: true
        }
      },
      // 权限管理
      {
        path: 'permission',
        name: 'Permission',
        meta: {
          title: '权限管理',
          icon: 'Lock',
          requiresAuth: true
        },
        children: [
          // 企业用户
          {
            path: 'user',
            name: 'User',
            component: () => import('@/views/permission/user/list.vue'),
            meta: {
              title: '企业用户',
              requiresAuth: true
            }
          },
          // 角色管理
          {
            path: 'role',
            name: 'Role',
            component: () => import('@/views/permission/role/list.vue'),
            meta: {
              title: '角色管理',
              requiresAuth: true
            }
          },
          // 菜单管理
          {
            path: 'menu',
            name: 'Menu',
            component: () => import('@/views/permission/menu/list.vue'),
            meta: {
              title: '菜单管理',
              requiresAuth: true
            }
          },
          // 部门管理
          {
            path: 'dept',
            name: 'Dept',
            component: () => import('@/views/permission/dept/list.vue'),
            meta: {
              title: '部门管理',
              requiresAuth: true
            }
          },
          // 岗位管理
          {
            path: 'post',
            name: 'Post',
            component: () => import('@/views/permission/post/list.vue'),
            meta: {
              title: '岗位管理',
              requiresAuth: true
            }
          }
        ]
      },
      // 角色菜单权限分配（隐藏路由，仅从角色管理跳转）
      {
        path: 'permission/menu/assign/:id',
        name: 'MenuAssign',
        component: () => import('@/views/permission/menu/assign.vue'),
        meta: {
          title: '菜单权限分配',
          requiresAuth: true
        }
      },
      // 角色数据权限分配（隐藏路由，仅从角色管理跳转）
      {
        path: 'permission/data/assign/:id',
        name: 'DataAssign',
        component: () => import('@/views/permission/data/assign.vue'),
        meta: {
          title: '数据权限分配',
          requiresAuth: true
        }
      },
      // 路线管理
        {
            path: 'route',
            name: 'Route',
            meta: {
              title: '路线管理',
              icon: 'Location',
              requiresAuth: true
            },
            children: [
              // 路线列表
              {
                path: 'list',
                name: 'RouteList',
                component: () => import('@/views/route/list.vue'),
                meta: {
                  title: '路线列表',
                  requiresAuth: true
                }
              },

              // 路线详情页（动态路由）
              {
                path: 'detail/:id',
                component: () => import('@/views/route/detail.vue'),
                meta: {
                  title: '路线详情',
                  requiresAuth: true
                }
              },
              // 路线编辑页（动态路由）
              {
                path: 'edit/:id',
                component: () => import('@/views/route/edit.vue'),
                meta: {
                  title: '编辑路线',
                  requiresAuth: true
                }
              },
              // 行程活动管理（独立页面）
              {
                path: 'activity',
                name: 'RouteActivity',
                component: () => import('@/views/route/activity-manager.vue'),
                meta: {
                  title: '行程活动',
                  requiresAuth: true
                }
              },
              // 行程活动页（动态路由）
              {
                path: 'activity/:scheduleId',
                component: () => import('@/views/route/activity.vue'),
                meta: {
                  title: '行程活动',
                  requiresAuth: true
                }
              },
              // 路线订单管理
              {
                path: 'orders',
                name: 'RouteOrders',
                component: () => import('@/views/route/route-orders.vue'),
                meta: {
                  title: '路线订单',
                  requiresAuth: true
                }
              },
              // 路线分类管理
              {
                path: 'category',
                name: 'Category',
                component: () => import('@/views/category/list.vue'),
                meta: {
                  title: '路线分类',
                  requiresAuth: true
                }
              }
            ]
          },
      // 景区管理
      {
        path: 'scenic',
        name: 'Scenic',
        meta: {
          title: '景区管理',
          icon: 'Picture',
          requiresAuth: true
        },
        children: [
          // 景区列表
          {
            path: 'list',
            name: 'ScenicList',
            component: () => import('@/views/scenic/list.vue'),
            meta: {
              title: '景区列表',
              requiresAuth: true
            }
          }
        ]
      },

      // 积分管理
      {
        path: 'points',
        name: 'Points',
        meta: {
          title: '积分管理',
          icon: 'Coin',
          requiresAuth: true
        },
        children: [
          // 积分列表
          {
            path: 'list',
            name: 'PointsList',
            component: () => import('@/views/points/list.vue'),
            meta: {
              title: '积分列表',
              requiresAuth: true
            }
          },
          // 积分兑换订单
          {
            path: 'exchange-order',
            name: 'ExchangeOrderList',
            component: () => import('@/views/points/exchangeOrderList.vue'),
            meta: {
              title: '积分兑换订单',
              requiresAuth: true
            }
          }
        ]
      },
      // 商品管理
        {
          path: 'product',
          name: 'Product',
          meta: {
            title: '商品管理',
            icon: 'ShoppingCart',
            requiresAuth: true
          },
          children: [
            // 商品列表
            {
              path: 'list',
              name: 'ProductList',
              component: () => import('@/views/product/list.vue'),
              meta: {
                title: '商品列表',
                requiresAuth: true
              }
            },
            // 商品分类
            {
              path: 'category',
              name: 'ProductCategory',
              component: () => import('@/views/product/category/list.vue'),
              meta: {
                title: '商品分类',
                requiresAuth: true
              }
            },
            // 商品标签
            {
              path: 'tag',
              name: 'ProductTag',
              component: () => import('@/views/product/tag/list.vue'),
              meta: {
                title: '商品标签',
                requiresAuth: true
              }
            },
            // 商品订单管理
            {
              path: 'orders',
              name: 'ProductOrders',
              component: () => import('@/views/product/product-orders.vue'),
              meta: {
                title: '商品订单',
                requiresAuth: true
              }
            }
          ]
        },
      // 小程序管理
      {
        path: 'mini-program',
        name: 'MiniProgram',
        meta: {
          title: '小程序管理',
          icon: 'Cellphone',
          requiresAuth: true
        },
        children: [
          // 小程序用户列表
          {
            path: 'user',
            name: 'MiniUserList',
            component: () => import('@/views/user/list.vue'),
            meta: {
              title: '小程序用户',
              requiresAuth: true
            }
          },
          // 生日提醒
          {
            path: 'birthday',
            name: 'BirthdayReminder',
            component: () => import('@/views/user/birthday.vue'),
            meta: {
              title: '生日提醒',
              requiresAuth: true
            }
          },
          // 轮播图列表
          {
            path: 'banner',
            name: 'BannerList',
            component: () => import('@/views/banner/list.vue'),
            meta: {
              title: '轮播图列表',
              requiresAuth: true
            }
          },
          // 足迹管理
          {
            path: 'footprint',
            name: 'FootprintList',
            component: () => import('@/views/footprint/list.vue'),
            meta: {
              title: '足迹管理',
              requiresAuth: true
            }
          }
        ]
      },
      // 会员管理
      {
        path: 'member',
        name: 'Member',
        meta: {
          title: '会员管理',
          icon: 'UserFilled',
          requiresAuth: true
        },
        children: [
          {
            path: 'level',
            name: 'MemberLevel',
            component: () => import('@/views/member/level-list.vue'),
            meta: {
              title: '会员等级',
              requiresAuth: true
            }
          }
        ]
      },
      // 客服聊天管理
      {
        path: 'chat',
        name: 'Chat',
        component: () => import('@/views/chat/index.vue'),
        meta: {
          title: '客服聊天',
          icon: 'ChatDotRound',
          requiresAuth: true
        }
      },
      // 系统管理
      {
        path: 'system',
        name: 'System',
        meta: {
          title: '系统管理',
          icon: 'Setting',
          requiresAuth: true
        },
        children: [
          // 系统配置
          {
            path: 'config',
            name: 'Config',
            component: () => import('@/views/system/config.vue'),
            meta: {
              title: '系统配置',
              requiresAuth: true
            }
          },
          // 消息管理
          {
            path: 'message',
            name: 'Message',
            component: () => import('@/views/message/list.vue'),
            meta: {
              title: '消息管理',
              requiresAuth: true
            }
          },
          // 短信配置
          {
            path: 'sms-config',
            name: 'SmsConfig',
            component: () => import('@/views/sms/config-list.vue'),
            meta: {
              title: '短信配置',
              requiresAuth: true
            }
          },
          // 短信模板
          {
            path: 'sms-template',
            name: 'SmsTemplate',
            component: () => import('@/views/sms/template-list.vue'),
            meta: {
              title: '短信模板',
              requiresAuth: true
            }
          },
          // 支付记录查询
          {
            path: 'payment-records',
            name: 'PaymentRecords',
            component: () => import('@/views/order/payment-records.vue'),
            meta: {
              title: '支付记录查询',
              requiresAuth: true
            }
          }
        ]
      }
    ]
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title + ' - 旅游路线小程序管理后台'
  } else {
    document.title = '旅游路线小程序管理后台'
  }
  
  // 验证登录状态
  if (to.meta.requiresAuth) {
    const token = sessionStorage.getItem('token')
    if (!token) {
      // 未登录，跳转到登录页
      next({ name: 'Login' })
      return
    }
  }
  
  next()
})

export default router